import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { selectIsAuthenticated, useAuthStore } from '@/features/auth/auth.store';

/**
 * Exige una sesión activa. Si no la hay, redirige al login recordando la ruta
 * solicitada para volver a ella después de autenticarse.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const isAuthenticated = useAuthStore(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return <>{children}</>;
}
